var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryOperations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 245,
    viewBox: "0 0 394 245",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4130_7737)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "#F4F8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4130_7737)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_4130_7737)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 122,
    r: 56,
    fill: "url(#paint0_linear_4130_7737)",
    fillOpacity: 0.08
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 196,
    cy: 122,
    r: 62,
    stroke: "white",
    strokeWidth: 12
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_4130_7737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M178 114L202 114M202 114C202 117.314 204.686 120 208 120C211.314 120 214 117.314 214 114C214 110.686 211.314 108 208 108C204.686 108 202 110.686 202 114ZM190 130L214 130M190 130C190 133.314 187.314 136 184 136C180.686 136 178 133.314 178 130C178 126.686 180.686 124 184 124C187.314 124 190 126.686 190 130Z",
    stroke: "url(#paint1_linear_4130_7737)",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 5.17822,
    y: 16.2676,
    width: 382.822,
    height: 296.732
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_1_4130_7737_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_4130_7737)",
    "data-figma-bg-blur-radius": 20
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 121.5C28.5817 121.5 24.9805 125.084 25.1865 129.497C26.2916 153.17 32.2929 176.388 42.8443 197.672C54.5816 221.349 71.6317 241.993 92.6639 257.993C113.696 273.993 138.141 284.916 164.091 289.91C190.042 294.904 216.795 293.833 242.263 286.782C267.731 279.73 291.225 266.888 310.912 249.259C330.598 231.629 345.944 209.688 355.751 185.149C365.559 160.61 369.563 134.137 367.451 107.795C365.553 84.1147 358.758 61.1167 347.53 40.2469C345.437 36.356 340.505 35.1347 336.716 37.4072L281.664 70.4239C277.875 72.6964 276.68 77.5973 278.613 81.5707C283.576 91.7779 286.603 102.843 287.514 114.203C288.638 128.228 286.507 142.322 281.285 155.387C276.063 168.451 267.893 180.132 257.412 189.518C246.932 198.904 234.423 205.741 220.864 209.495C207.305 213.25 193.062 213.82 179.246 211.161C165.43 208.502 152.415 202.687 141.218 194.168C130.02 185.65 120.943 174.659 114.694 162.054C109.632 151.843 106.537 140.796 105.544 129.49C105.157 125.089 101.612 121.5 97.1938 121.5L33 121.5Z",
    fill: "white",
    fillOpacity: 0.6,
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4130_7737",
    x: 128,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.145098 0 0 0 0 0.396078 0 0 0 0 0.784314 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7737"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_4130_7737",
    x: 128,
    y: 54,
    width: 136,
    height: 136,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.317647 0 0 0 0 0.705882 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7737"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_4130_7737",
    x: 176,
    y: 106,
    width: 40,
    height: 33.2,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4130_7737"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_4130_7737",
    x: 5.17822,
    y: 16.2676,
    width: 382.822,
    height: 296.732,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4130_7737"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4130_7737",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_4130_7737_clip_path",
    transform: "translate(-5.17822 -16.2676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33 121.5C28.5817 121.5 24.9805 125.084 25.1865 129.497C26.2916 153.17 32.2929 176.388 42.8443 197.672C54.5816 221.349 71.6317 241.993 92.6639 257.993C113.696 273.993 138.141 284.916 164.091 289.91C190.042 294.904 216.795 293.833 242.263 286.782C267.731 279.73 291.225 266.888 310.912 249.259C330.598 231.629 345.944 209.688 355.751 185.149C365.559 160.61 369.563 134.137 367.451 107.795C365.553 84.1147 358.758 61.1167 347.53 40.2469C345.437 36.356 340.505 35.1347 336.716 37.4072L281.664 70.4239C277.875 72.6964 276.68 77.5973 278.613 81.5707C283.576 91.7779 286.603 102.843 287.514 114.203C288.638 128.228 286.507 142.322 281.285 155.387C276.063 168.451 267.893 180.132 257.412 189.518C246.932 198.904 234.423 205.741 220.864 209.495C207.305 213.25 193.062 213.82 179.246 211.161C165.43 208.502 152.415 202.687 141.218 194.168C130.02 185.65 120.943 174.659 114.694 162.054C109.632 151.843 106.537 140.796 105.544 129.49C105.157 125.089 101.612 121.5 97.1938 121.5L33 121.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4130_7737",
    x1: 196,
    y1: 66,
    x2: 196,
    y2: 178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1151B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4130_7737",
    x1: 177.25,
    y1: 115.583,
    x2: 204.319,
    y2: 150.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2565C8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4130_7737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 393.333,
    height: 245,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibraryOperations);
export default __webpack_public_path__ + "static/media/library-operations.a86631056911d4471caea76b3936a237.svg";
export { ForwardRef as ReactComponent };